import React from 'react';

import { useAddressFormContext } from '../context';
import { AUFields } from './AU';
import { CAFields } from './CA';
import { DefaultFields } from './default';
import { FRFields } from './FR';
import { GBFields } from './GB';
import { NZFields } from './NZ';
import { USFields } from './US';
import { DEFields } from './DE';

const fieldsByCountry = {
  AU: AUFields,
  CA: CAFields,
  FR: FRFields,
  GB: GBFields,
  NZ: NZFields,
  US: USFields,
  DE: DEFields,
};

export const CountryFields = () => {
  const { address } = useAddressFormContext();
  const FieldsForCountry = fieldsByCountry[address?.countryCode] || DefaultFields;

  return <FieldsForCountry />;
};
